import React, { useCallback } from 'react';
import { useNavigate, useLocation, useParams, useMatch } from 'react-router-dom';
import Editor from './Editor';
import GroupEditor from './GroupEditor';

function WorkExperience() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const isOpen = location.state?.background;

  const handleClose = useCallback(() => {
    navigate('/resume', { replace: true });
  }, [navigate]);

  // Call all hooks unconditionally
  const matchWorkExperience = useMatch('/resume/work-experience');
  const matchWorkExperienceId = useMatch('/resume/work-experience/:id');
  const matchAddCompanyGroup = useMatch('/resume/add-company-group');
  const matchAddCompanyGroupId = useMatch('/resume/add-company-group/:id');
  const matchPositionInCompany = useMatch('/resume/position-in-company');
  const matchPositionInCompanyId = useMatch('/resume/position-in-company/:id');
  const matchCompany = useMatch('/resume/company');
  const matchCompanyId = useMatch('/resume/company/:id');

  if (!isOpen) return null;

  // Conditional rendering based on match results
  if (matchWorkExperience) {
    return <Editor onClose={handleClose} type="WorkExperience" />;
  }
  if (matchWorkExperienceId) {
    return <Editor onClose={handleClose} type="WorkExperience" workExperienceId={id} />;
  }
  if (matchAddCompanyGroup) {
    return <GroupEditor onClose={handleClose} listOfComp={location.state?.listOfComp ?? []} />;
  }
  if (matchAddCompanyGroupId) {
    return (
      <GroupEditor
        onClose={handleClose}
        listOfComp={location.state?.listOfComp ?? []}
        groupID={id}
      />
    );
  }
  if (matchPositionInCompany) {
    return <Editor onClose={handleClose} type="PositionInCompany" />;
  }
  if (matchPositionInCompanyId) {
    return (
      <Editor onClose={handleClose} type="PositionInCompany" workExperienceId={id} companyId={id} />
    );
  }
  if (matchCompany) {
    return <Editor onClose={handleClose} type="CompanyInformation" />;
  }
  if (matchCompanyId) {
    return <Editor onClose={handleClose} type="CompanyInformation" workExperienceId={id} />;
  }

  return null;
}

export default WorkExperience;
